import { render, staticRenderFns } from "./edit_patient.vue?vue&type=template&id=91575d58&scoped=true"
import script from "./edit_patient.vue?vue&type=script&lang=js"
export * from "./edit_patient.vue?vue&type=script&lang=js"
import style0 from "./edit_patient.vue?vue&type=style&index=0&id=91575d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91575d58",
  null
  
)

export default component.exports